// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2rIeH","list":"PatternAutocomplete_list__2WgQv"};